<div class="course-layout">
  <app-course-side-navbar [class.sidenav-disabled]="isQuizMode()"></app-course-side-navbar>
  <div class="course-main">
    <app-student-navbar-quiz-lesson (openSidebar)="openMobileSidebar()"></app-student-navbar-quiz-lesson>
    <div class="course-content-area">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>